/*
 * Created Date: Tue, 8th Dec 2020, 16:36:46 pm
 * Author: Kristyna Fojtikova
 * Email: kristyna.fojtikova@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { ActionButton } from 'Components/Buttons';
import { CameraAlt, Check, Close } from '@material-ui/icons';
import { actionButtonStyles } from 'styles';

const ChecklistQuestionsViewer = ({
  questions,
  setCurrentIndex,
  markQuestionDisaproved,
  markQuestionAprroved,
  disableEdit
  
  //   approveChecklist
}) => {
  const buttonClasses = actionButtonStyles(25);

  const totalWidth = 400;
  const margin = 15;

  const styles = {
    container: {
      height: totalWidth,
      display: 'flex',
      flexDirection: 'column',
      padding: margin,
      overflowY: 'scroll',
      flex: 1,
    },
    questionsContainer: {
      marginBottom: margin,
      paddingRight: 15,
    },
    questionRowContainer: {
      display: 'flex',
      width: '100%',
      alignItems: 'flex-start',
      marginTop: 8,
      marginBottom: 8,
      justifyContent: 'space-between',
    },
    questionText: {
      marginLeft: 10,
      marginRight: 10,
      fontSize: 14,
    },
    buttonsContainer: {
      display: 'flex',
      height: 28,
    },
    textContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: 5,
    },
  };

  const renderQuestionRow = (question, index) => {
    const approvedStatus = question.approved;
    return (
      <div
        style={styles.questionRowContainer}
        key={`question-row-${question.id}`}
      >
        <div style={styles.textContainer}>
          <ActionButton
            icon={<CameraAlt />}
            name=""
            onClick={() => setCurrentIndex(index)}
            className={buttonClasses.cameraButton}
          />
          <span style={styles.questionText}>{`${index + 1}.`}</span>
          <span style={styles.questionText}>{question.question}</span>
        </div>
        <div style={styles.buttonsContainer}>
          {disableEdit ? (
            approvedStatus ? (
              <>
              <ActionButton
                disabled={false}
                icon={<Check />}
                name=""
                onClick={() => markQuestionAprroved(index)}
                className={
                  approvedStatus === true
                    ? buttonClasses.checklistButtonApproved
                    : buttonClasses.checklistButton
                }
              />
              <ActionButton
                icon={<Close/>}
                onClick={() => markQuestionDisaproved(index)}
                name=""
                className={
                  approvedStatus === false
                    ? buttonClasses.checklistButtonDisapproved
                    : buttonClasses.checklistButton
                }
            />
            </>
            ) : (
              <ActionButton
                disabled={false}
                icon={<Close/>}
                name=""
                className= {buttonClasses.checklistButtonDisapproved}
              />
            )
          ) : (
            <>
            <ActionButton
              icon={<Check />}
              name=""
              onClick={() => markQuestionAprroved(index)}
              className={
                approvedStatus === true
                  ? buttonClasses.checklistButtonApproved
                  : buttonClasses.checklistButton
              }
            />
            <ActionButton
              icon={<Close />}
              name=""
              onClick={() => markQuestionDisaproved(index)}
              className={
                approvedStatus === false
                  ? buttonClasses.checklistButtonDisapproved
                  : buttonClasses.checklistButton
              }
            />
            </>
          )}
        </div>
      </div>
    );
  };

  //   const uncheckedQuestion = questions.find(q => q.approved !== true);

  return (
    <div key="checklist-questions-container-div" style={styles.container}>
      <div style={styles.questionsContainer}>
        {questions.map(renderQuestionRow)}
      </div>
      {/* <ActionButton
        icon={<Check />}
        disabled={uncheckedQuestion !== undefined}
        name={`resources.${resource}.approveChecklist`}
        onClick={approveChecklist}
        className={buttonClasses.checklistButtonApproved}
        /> */}
    </div>
  );
};

export default ChecklistQuestionsViewer;
